/**
 * Frontend-Only Error Codes
 * These codes are generated on the client side for errors that don't originate from the backend
 * Following the same CAT_0xx convention as backend codes
 */

export const CLIENT_ERROR_CODES = {
  // Request rejected by the server without an error code of its own (e.g. a
  // route/model binding failure), so there is nothing more specific to report.
  BAD_REQUEST: 'REQ_001',

  // Network errors (client-side)
  NETWORK_TIMEOUT: 'NET_001',
  NETWORK_OFFLINE: 'NET_002',
  NETWORK_CONNECTION_REFUSED: 'NET_003',
  NETWORK_ABORTED: 'NET_004',
  
  // Unknown/unexpected errors
  UNKNOWN_ERROR: 'UNK_001',
  PARSING_ERROR: 'UNK_002',
} as const;

export type ClientErrorCode = typeof CLIENT_ERROR_CODES[keyof typeof CLIENT_ERROR_CODES];

/**
 * Backend error codes reference (for documentation)
 * These are the codes we expect from the backend API
 * 
 * Authentication (AUTH_0xx):
 * - AUTH_001: AUTH_UNAUTHENTICATED (401 - Not logged in, requires logout + redirect)
 * - AUTH_002: AUTH_UNAUTHORIZED (403 - Forbidden, no logout required)
 * - AUTH_003: AUTH_INVALID_CREDENTIALS
 * - AUTH_004: AUTH_TOKEN_EXPIRED
 * - AUTH_005: AUTH_SESSION_INVALID
 * - AUTH_006: AUTH_MISSING_CREDENTIALS
 * - AUTH_007: AUTH_INVALID_KEY
 * - AUTH_008: AUTH_MISSING_KEY
 * 
 * Validation (VAL_0xx):
 * - VAL_001: VAL_REQUIRED_FIELD
 * - VAL_002: VAL_INVALID_FORMAT
 * - VAL_003: VAL_OUT_OF_RANGE
 * - VAL_004: VAL_DUPLICATE_VALUE
 * 
 * Business Logic (BUS_0xx):
 * - BUS_001: BUS_APPLICATION_LOCKED
 * - BUS_002: BUS_SECTION_INCOMPLETE
 * - BUS_003: BUS_ALREADY_SUBMITTED
 * - BUS_004: BUS_NOT_FOUND
 *
 * Server Errors (SRV_0xx):
 * - SRV_001: SRV_INTERNAL_ERROR
 * - SRV_002: SRV_DATABASE_ERROR
 * - SRV_003: SRV_EXTERNAL_SERVICE_ERROR
 */
